export default __webpack_public_path__ + "static/media/garlic.66d3807b.png";